export const name = "NORMALIZE";
export const summary = `Case-sensitively normalizes the characters in a \`STRING\` value.`;
export const reference = `
## NORMALIZE

Case-sensitively normalizes the characters in a \`STRING\` value.

\`\`\`
NORMALIZE(value[, normalization_mode])
\`\`\`

### Description

Takes a string value and returns it as a normalized string. If you don't provide a normalization mode, \`NFC\` is used.

Normalization is used to ensure that two strings are equivalent. Normalization is often used in situations in which two strings render the same on the screen but have different Unicode code points.

\`NORMALIZE\` supports four optional normalization modes:

| Value | Name | Description |
| --- | --- | --- |
| \`NFC\` | Normalization Form Canonical Composition | Decomposes and recomposes characters by canonical equivalence. |
| \`NFKC\` | Normalization Form Compatibility Composition | Decomposes characters by compatibility, then recomposes them by canonical equivalence. |
| \`NFD\` | Normalization Form Canonical Decomposition | Decomposes characters by canonical equivalence, and multiple combining characters are arranged in a specific order. |
| \`NFKD\` | Normalization Form Compatibility Decomposition | Decomposes characters by compatibility, and multiple combining characters are arranged in a specific order. |


### Return type

\`STRING\`


### Examples

The following example normalizes different language characters:



\`\`\`
SELECT
  NORMALIZE('\\u00ea') as a,
  NORMALIZE('\\u0065\\u0302') as b,
  NORMALIZE('\\u00ea') = NORMALIZE('\\u0065\\u0302') as normalized;

/*---+---+------------*
 | a | b | normalized |
 +---+---+------------+
 | ê | ê | TRUE |
 *---+---+------------*/
\`\`\`

The following examples normalize different space characters:



\`\`\`
SELECT NORMALIZE('Raha\\u2004Mahan', NFKC) AS normalized_name

/*-----------------*
 | normalized_name |
 +-----------------+
 | Raha Mahan |
 *-----------------*/
\`\`\`



\`\`\`
SELECT NORMALIZE('Raha\\u2005Mahan', NFKC) AS normalized_name

/*-----------------*
 | normalized_name |
 +-----------------+
 | Raha Mahan |
 *-----------------*/
\`\`\`



\`\`\`
SELECT NORMALIZE('Raha\\u2006Mahan', NFKC) AS normalized_name

/*-----------------*
 | normalized_name |
 +-----------------+
 | Raha Mahan |
 *-----------------*/
\`\`\`



\`\`\`
SELECT NORMALIZE('Raha Mahan', NFKC) AS normalized_name

/*-----------------*
 | normalized_name |
 +-----------------+
 | Raha Mahan |
 *-----------------*/
\`\`\`


source: https://cloud.google.com/bigquery/docs/reference/standard-sql/string_functions
`;
